(function ($, window) {
    $(document).ready(init);
    $(document).on('sectionPersonList.frontend.ready', init);

    /**
     * Function for making the navigation on the personel page sticky and text-with-menu section
     * Documentation: https://abouolia.github.io/sticky-sidebar/
     */
    function init() {
        var $nav = $('.submenu');

        if ($nav.length > 0) { // null check
            new StickySidebar('.submenu', {
                topSpacing: 20,
                bottomSpacing: 0,
                containerSelector: '.article-content',
                innerWrapperSelector: '.submenu__navigation',
                minWidth: 1200
            });

            /*
             * Handling the opening and closing of the sidenav
             */
            var $menuButton = $('.submenu__navigation-button');

            //Bind the menu button
            $menuButton.off().on('click', function () {
                $nav.toggleClass('submenu--collapsed');
            });
        }
    }

})(jQuery, window);